import noNilArray from 'utils/arrays/noNilArray.util';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import logger from 'utils/logger.util';

const L = logger('STRINGS'); // eslint-disable-line no-unused-vars

export const concatTag = (...tags) => noNilArray(noNilArray(tags).map(fromAnyToTrimmed)).join(' | ');

export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
